import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CDN_IMAGES } from '../../constants/param-constants';

export interface UpsellModalContent {
  title: string;
  message: string;
  buttonText: string;
  html: string;
}

@Component({
    selector: 'upsell-modal',
    templateUrl: './upsell-modal.component.html',
    styleUrls: ['./upsell-modal.component.scss'],
    standalone: false
})
export class UpsellModalComponent implements OnInit, OnDestroy {
  CDN_IMAGES = CDN_IMAGES;
  constructor(private cdr: ChangeDetectorRef) {}

  // [DEV-54196] Per-field default reproduces the old setModalData() behavior: a page overrides any field
  // via the block's JSON options; anything omitted keeps the default "deep discounts" copy.
  @Input() set upsellModalInputs(value: Partial<UpsellModalContent> | null | undefined) {
    this._upsellModalInputs = {
      title: value?.title || 'WAIT! Deeply discounted add-ons available!',
      message: value?.message || 'Enjoy fantastic benefits like:<ul><li>Smoother Digestion</li><li>easier weight management</li><li>More energy</li></ul>To thank you for your business, we\'re offering you <b>DEEP DISCOUNTS</b> on formulas to help accelerate your results. You may not ever see discounts this low again — act now to secure your savings.',
      buttonText: value?.buttonText || 'CLAIM YOUR DISCOUNTS',
      html: value?.html || ''
    };
    this.cdr.detectChanges();
  }
  get upsellModalInputs(): UpsellModalContent {
    return this._upsellModalInputs;
  }
  private _upsellModalInputs: UpsellModalContent = { title: '', message: '', buttonText: '', html: '' };

  show: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() cta = new EventEmitter<void>();

  private autoOpenTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit() {
    // The hasModal gate + 1.5s setTimeout that used to live in USGenericComponent: rendering this
    // component already means the page opted in, so just schedule the auto-open here.
    this.autoOpenTimer = setTimeout(() => this.open(), 1500);
  }

  ngOnDestroy() {
    if (this.autoOpenTimer) {
      clearTimeout(this.autoOpenTimer);
    }
    this.unlockScroll();
  }

  open() {
    this.show = true;
    this.lockScroll();
    this.cdr.detectChanges();
  }

  onClose() {
    this.show = false;
    this.unlockScroll();
    this.close.emit();
    this.cdr.detectChanges();
  }

  onCTA() {
    this.cta.emit();
    this.onClose();
  }

  onBackdropClick(event: Event) {
    // Only close if clicking the backdrop (not the modal content)
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  private lockScroll() {
    document.body.classList.add('noscroll');
    const scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    if (scrollAvoid) scrollAvoid.classList.add('avoid');
  }

  private unlockScroll() {
    document.body.classList.remove('noscroll');
    const scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    if (scrollAvoid) scrollAvoid.classList.remove('avoid');
  }
}
